/* V196 — design alert stays tied to 3 unique product-card views, then waits for a neutral UI moment. */
(() => {
  const root = document.querySelector('[data-jol-design-alert]');
  const configNode = document.getElementById('JolDesignAlertConfig');
  let config = { enabled: true, threshold: 3, dropCount: 4, cooldownDays: 21, customerSubscribed: false };
  if (configNode) {
    try { config = { ...config, ...JSON.parse(configNode.textContent || '{}') }; } catch (_) {}
  }

  const params = new URLSearchParams(location.search);
  const testMode = params.get('test') === 'email' || params.get('jol-email-test') === '1';

  const KEYS = {
    viewed: 'jolDesignAlertViewedV185',
    dismissedAt: 'jolDesignAlertDismissedAtV185',
    subscribed: 'jolDesignAlertSubscribedV185',
    shownSession: 'jolDesignAlertShownSessionV185'
  };
  const safeGet = (store, key) => { try { return store.getItem(key); } catch (_) { return null; } };
  const safeSet = (store, key, value) => { try { store.setItem(key, value); } catch (_) {} };
  const safeRemove = (store, key) => { try { store.removeItem(key); } catch (_) {} };
  const emit = (name, detail={}) => {
    document.dispatchEvent(new CustomEvent(name, { detail }));
    if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event:name, ...detail });
  };

  const isSubscribed = () => config.customerSubscribed === true || safeGet(localStorage, KEYS.subscribed) === '1';
  if (config.customerSubscribed === true) safeSet(localStorage, KEYS.subscribed, '1');

  const getViewed = () => {
    try {
      const parsed = JSON.parse(safeGet(localStorage, KEYS.viewed) || '[]');
      return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
    } catch (_) { return []; }
  };
  const recordView = (handle, eligible=true) => {
    if (!eligible || !handle || isSubscribed()) return;
    const viewed = getViewed();
    if (!viewed.includes(handle)) {
      viewed.push(handle);
      safeSet(localStorage, KEYS.viewed, JSON.stringify(viewed.slice(-40)));
    }
    queueShow(900);
  };

  const cooldownActive = () => {
    const stamp = Number(safeGet(localStorage, KEYS.dismissedAt) || 0);
    if (!stamp) return false;
    const duration = Math.max(1, Number(config.cooldownDays) || 21) * 86400000;
    return Date.now() - stamp < duration;
  };
  const isBrowsingSurface = () => {
    if (/^\/cart(?:\/|$)/.test(location.pathname) || /^\/checkouts?\//.test(location.pathname)) return false;
    if (document.body?.classList.contains('template-policy') || document.body?.classList.contains('template-cart')) return false;
    return !!document.querySelector('[data-jol-homepage], [data-jol-product-card], .template-product, [data-jol-catalog-tabs]');
  };
  const neutral = () => {
    if (!isBrowsingSurface()) return false;
    if (document.querySelector('.jol-overlay.is-open')) return false;
    const fit = document.querySelector('[data-jol-fit-guide-overlay]');
    if (fit && !fit.hidden) return false;
    if (document.querySelector('[data-jol-design-alert].is-open')) return false;
    if (document.body?.classList.contains('jol-ui-lock')) return false;
    const active = document.activeElement;
    if (active?.matches?.('select, input:not([type="hidden"]), textarea')) return false;
    return true;
  };
  const canShow = () => {
    if (!root) return false;
    if (config.enabled === false && !testMode) return false;
    if (!testMode && isSubscribed()) return false;
    if (!testMode && getViewed().length < Math.max(1, Number(config.threshold) || 3)) return false;
    if (!testMode && safeGet(sessionStorage, KEYS.shownSession) === '1') return false;
    if (!testMode && cooldownActive()) return false;
    return neutral();
  };

  let showTimer = 0;
  function queueShow(delay=700) {
    if (!root) return;
    window.clearTimeout(showTimer);
    showTimer = window.setTimeout(() => { if (canShow()) openPrompt(); }, delay);
  }
  const openPrompt = () => {
    if (!root || !canShow()) return;
    if (!testMode) safeSet(sessionStorage, KEYS.shownSession, '1');
    root.hidden = false;
    requestAnimationFrame(() => {
      root.classList.add('is-open');
      root.querySelector('input[type="email"]')?.focus({ preventScroll:true });
    });
    emit('design_alert_prompt_shown', { unique_product_views:getViewed().length });
  };
  const closePrompt = ({ dismissed=true }={}) => {
    if (!root || root.hidden) return;
    root.classList.remove('is-open');
    if (dismissed) {
      safeSet(localStorage, KEYS.dismissedAt, String(Date.now()));
      emit('design_alert_prompt_dismissed', { cooldown_days:Number(config.cooldownDays) || 21 });
    }
    window.setTimeout(() => { if (!root.classList.contains('is-open')) root.hidden = true; }, 240);
  };
  const markSubscribed = (source) => {
    safeSet(localStorage, KEYS.subscribed, '1');
    safeRemove(localStorage, KEYS.dismissedAt);
    document.querySelectorAll('[data-jol-design-alert-inline]').forEach(el => el.classList.add('is-subscribed'));
    emit(source === 'inline' ? 'design_alert_inline_signup' : 'design_alert_signup', { drop_count:Number(config.dropCount) || 4 });
  };

  async function submitCustomerForm(form, source, statusNode) {
    const button = form.querySelector('button[type="submit"]');
    const original = button?.textContent || '';
    if (button) { button.disabled = true; button.textContent = 'Saving…'; }
    if (statusNode) statusNode.textContent = '';
    try {
      const response = await fetch(form.action, {
        method:'POST',
        body:new FormData(form),
        credentials:'same-origin',
        headers:{ 'Accept':'text/html', 'X-Requested-With':'XMLHttpRequest' }
      });
      const html = await response.text();
      const challenged = /captcha|challenge-platform|shopify-challenge/i.test(`${response.url} ${html.slice(0,12000)}`);
      const rejected = !response.ok || /class=["'][^"']*errors|form__message[^>]*>\s*(?:Please|Email|Error)/i.test(html);
      if (challenged || rejected) throw new Error('verification');
      markSubscribed(source);
      if (source === 'popup' && root) {
        root.querySelector('[data-jol-design-alert-content]')?.setAttribute('hidden','');
        root.querySelector('[data-jol-design-alert-success]')?.removeAttribute('hidden');
        window.setTimeout(() => closePrompt({ dismissed:false }), 1800);
      } else if (statusNode) {
        statusNode.textContent = `You got it. We'll let you know when ${Number(config.dropCount) || 4}+ designs drop.`;
      }
    } catch (_) {
      if (statusNode) statusNode.textContent = 'Could not save that email yet. Please try again.';
      if (button) { button.disabled = false; button.textContent = original; }
      return;
    }
    if (button) { button.disabled = false; button.textContent = original; }
  }

  const diagnose = () => ({
    version: 'V196',
    rootPresent: !!root,
    enabled: config.enabled !== false,
    testMode,
    threshold: Math.max(1, Number(config.threshold) || 3),
    viewed: getViewed(),
    viewedCount: getViewed().length,
    subscribed: isSubscribed(),
    shownThisSession: safeGet(sessionStorage, KEYS.shownSession) === '1',
    cooldownActive: cooldownActive(),
    browsingSurface: isBrowsingSurface(),
    neutral: neutral(),
    canShow: canShow()
  });
  window.LuckJarDesignAlerts = {
    diagnose,
    reset() {
      safeRemove(localStorage, KEYS.viewed);
      safeRemove(localStorage, KEYS.dismissedAt);
      safeRemove(localStorage, KEYS.subscribed);
      safeRemove(sessionStorage, KEYS.shownSession);
      return diagnose();
    },
    show() { queueShow(0); return diagnose(); }
  };

  if (root) {
    root.querySelector('[data-jol-design-alert-close]')?.addEventListener('click', () => closePrompt());
    root.addEventListener('click', e => { if (e.target === root) closePrompt(); });
    root.querySelector('.jol-design-alert__form')?.addEventListener('submit', e => {
      e.preventDefault();
      submitCustomerForm(e.currentTarget, 'popup', root.querySelector('[data-jol-design-alert-status]'));
    });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && root.classList.contains('is-open')) { e.preventDefault(); closePrompt(); }
    });
  }

  document.querySelectorAll('.jol-design-alert-inline__form').forEach(form => {
    form.addEventListener('submit', e => {
      e.preventDefault();
      submitCustomerForm(form, 'inline', form.querySelector('[data-jol-design-alert-inline-status]'));
    });
  });
  if (isSubscribed()) document.querySelectorAll('[data-jol-design-alert-inline]').forEach(el => el.classList.add('is-subscribed'));

  document.addEventListener('click', e => {
    const profileControl = e.target.closest?.('[data-jol-profile-account]');
    if (profileControl) emit('luck_jar_profile_clicked', { location: location.pathname });
  });

  document.addEventListener('jol:product-view', e => {
    const detail = e.detail || {};
    recordView(String(detail.handle || ''), detail.eligible !== false);
  });
  document.addEventListener('jol:ui-neutral', () => queueShow(520));
  document.addEventListener('visibilitychange', () => { if (!document.hidden) queueShow(800); });

  if (testMode) {
    queueShow(350);
  } else if (root?.dataset.productEligible === 'true' && root.dataset.productHandle) {
    recordView(root.dataset.productHandle, true);
  } else {
    queueShow(1300);
  }
})();
